export default __webpack_public_path__ + "static/media/logo.de23b266.png";